export default "__VITE_PUBLIC_ASSET__9e94ab82__"